export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 7.7dc89be9.mp4";